import apisauce from 'apisauce';
import apiConfig from '../../conf/api';
import config from '../../conf';
import { getSessionInfo } from '../JwtStore';

function create(baseURL = apiConfig.baseUrl) {
  let api = apisauce.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'Cache-Control': 'no-cache',
      credentials: 'include',
    },
    timeout: apiConfig.timeout,
  });

  if (config.isStandalone) {
    let { access_token } = getSessionInfo() || {};
    if (access_token) api.setHeader('Authorization', `Bearer ${access_token}`);
  }

  const transformObjectApplicationData = object => {
    Object.keys(object).forEach(function(key) {
      if (typeof object[key] === 'object' && object[key]) {
        object[key] = object[key].id;
      }
    });
  };
  function setToken(token) {
    // ignore if not running as standalone
    if (config.isStandalone) api.setHeader('Authorization', `Bearer ${token}`);
  }

  function clearToken() {
    delete api.headers['Authorization'];
  }

  function register(email, password) {
    return api.post(apiConfig.routes.register, {
      login: email,
      email,
      langKey: 'en',
      password,
    });
  }

  function login(email, password) {
    return api.post(apiConfig.routes.login, {
      username: email,
      password,
      rememberMe: true,
    });
  }

  function changePassword(currentPassword, newPassword) {
    return api.post(apiConfig.routes.login, { currentPassword, newPassword });
  }

  function logout() {
    let result = api.post(apiConfig.routes.logout, {});
    delete api.headers['Authorization'];
    return result;
  }

  function getSession() {
    return api.get(apiConfig.routes.getSession);
  }

  function getConfiguration() {
    return api.get(apiConfig.routes.getConfiguration);
  }

  function getUsers() {
    return api.get(apiConfig.routes.getUsers);
  }

  function getApplications(filters) {
    return api.get(`${apiConfig.routes.getVisaApplications}${filters}`);
  }

  function activateAccount(key) {
    return api.get(`${apiConfig.routes.activate}${key}`);
  }

  function initPasswordReset(mail) {
    return api.post(
      apiConfig.routes.passwordChangeInit,
      mail,
      // If the content-type isn't set that way, axios will try to
      // encode the body and thus modify the data sent to the server.
      { headers: { 'Content-Type': 'text/plain' } }
    );
  }

  function finishPasswordReset(key, newPassword) {
    return api.post(apiConfig.routes.passwordChangeFinish, {
      key,
      newPassword,
    });
  }

  function createApplication(data) {
    transformObjectApplicationData(data);
    return api.post(apiConfig.routes.createApplication, data);
  }

  function saveApplication(data) {
    transformObjectApplicationData(data);
    return api.put(apiConfig.routes.updateApplication(data.uuid), data);
  }

  function submitApplication(data) {
    return api.post(apiConfig.routes.completeApplication(data.uuid), data);
  }

  function uploadDocument(applicationId, file, documentTypeId, docUuid) {
    let data = new FormData();
    data.append('document', file);
    return docUuid
      ? api.post(
          apiConfig.routes.updateDocument(
            applicationId,
            documentTypeId,
            docUuid
          ),
          data
        )
      : api.post(
          apiConfig.routes.uploadDocument(applicationId, documentTypeId),
          data
        );
  }

  function deleteDocument(applicationId, documentTypeId, docUuid) {
    return api.delete(
      apiConfig.routes.updateDocument(applicationId, documentTypeId, docUuid)
    );
  }

  function getVisaFees(visatypeId) {
    return api.get(apiConfig.routes.getVisaFees(visatypeId));
  }

  function getQuote(data) {
    return api.post(apiConfig.routes.getQuote, {
      ...data,
      paymentMethodId: data.paymentMethodId,
    });
  }

  function getExistedQuote(uuid) {
    return api.get(apiConfig.routes.getExistedQuote(uuid));
  }

  function pay(data) {
    return api.post(apiConfig.routes.pay, data);
  }

  function submitPayment(uuid, status) {
    return api.post(apiConfig.routes.submitPayment(uuid, status));
  }

  function respondToAgent(applicationId, message, documentIds) {
    return api.post(apiConfig.routes.messageAgent(applicationId), {
      message,
      documentIds,
    });
  }

  function messageToApplicant(applicationId, message) {
    return api.post(apiConfig.routes.messageToApplicant(applicationId), {
      message,
    });
  }

  function getPaymentMethods(isLAO) {
    return api.get(apiConfig.routes.getPaymentMethods(isLAO));
  }

  function sendPaymentLink(uuid) {
    return api.post(apiConfig.routes.sendPaymentLink(uuid));
  }

  function markForLocalPayment(uuid) {
    return api.post(apiConfig.routes.markForLocalPayment(uuid));
  }

  function getPaymentInfo(uuid) {
    return api.get(apiConfig.routes.getPaymentInfo(uuid));
  }

  function getApplication(uuid) {
    return api.get(apiConfig.routes.getApplication(uuid));
  }
  function checkZeroPayment(applicationId) {
    return api.post(apiConfig.routes.isZeroPayment(applicationId));
  }

  function downloadApplication(applicationId) {
    return api.get(
      apiConfig.routes.downloadApplication(applicationId),
      {},
      {
        responseType: 'blob',
      }
    );
  }

  return {
    login,
    logout,
    register,
    getSession,
    getUsers,
    activateAccount,
    changePassword,
    initPasswordReset,
    finishPasswordReset,
    getConfiguration,
    getApplications,
    setToken,
    clearToken,
    createApplication,
    saveApplication,
    submitApplication,
    uploadDocument,
    deleteDocument,
    getVisaFees,
    getQuote,
    getExistedQuote,
    pay,
    submitPayment,
    respondToAgent,
    messageToApplicant,
    getPaymentMethods,
    sendPaymentLink,
    markForLocalPayment,
    getPaymentInfo,
    getApplication,
    checkZeroPayment,
    downloadApplication,
  };
}

export default {
  create,
};



// WEBPACK FOOTER //
// ./src/services/Api/Api.live.js